import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Poudre = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.66 114.78">
  <G fill={color}>
    <Path d="M73.71,24.36L27.92.48c-1-.52-2.17-.62-3.24-.29-1.08.34-1.97,1.09-2.5,2.09L.14,44.56c-1.09,2.08-.28,4.65,1.81,5.74l35.65,18.59c.61.32,1.29.48,1.97.48.43,0,.86-.07,1.28-.2,1.08-.34,1.97-1.09,2.5-2.09.89-1.7,2.38-2.96,4.22-3.53,1.83-.58,3.78-.4,5.48.48,1,.52,2.17.62,3.24.29,1.08-.34,1.98-1.09,2.5-2.09l16.75-32.13c1.09-2.08.28-4.65-1.81-5.74ZM52.92,55.03c-2.6-.55-5.32-.42-7.93.4-2.61.82-4.91,2.27-6.73,4.21l-28.62-14.92L27.76,9.99l38.25,19.94-13.09,25.1Z"/>
    <Path d="M21.05,41.17c.34,1.08,1.09,1.97,2.09,2.5l17.9,9.33c.61.32,1.29.48,1.97.48.43,0,.86-.07,1.28-.2,1.08-.34,1.97-1.09,2.5-2.09l7.53-14.45c1.09-2.08.28-4.65-1.81-5.74l-17.9-9.33c-2.08-1.09-4.65-.28-5.74,1.8l-7.54,14.45c-.52,1-.62,2.17-.29,3.24ZM34.45,31.18l10.35,5.4-3.6,6.9-10.35-5.4,3.6-6.91Z"/>
    <Circle cx="50.24" cy="75.45" r="4.51"/>
    <Path d="M46.56,88.91c0-2.49-2.02-4.51-4.51-4.51s-4.51,2.02-4.51,4.51,2.02,4.51,4.51,4.51,4.51-2.02,4.51-4.51Z"/>
    <Circle cx="59.26" cy="93.97" r="4.51"/>
    <Circle cx="29.7" cy="105.9" r="4.51"/>
    <Circle cx="47.67" cy="104.51" r="4.51"/>
    <Circle cx="63.42" cy="111.32" r="4.51"/>
    <Path d="M73.39,24.14L28.01.48c-.99-.52-2.15-.62-3.21-.28-1.07.33-1.96,1.08-2.47,2.07L.48,44.16c-1.08,2.06-.28,4.61,1.79,5.69l35.33,18.42c.61.32,1.28.48,1.95.48.43,0,.85-.06,1.27-.19,1.07-.33,1.96-1.08,2.47-2.07.88-1.69,2.36-2.93,4.18-3.5,1.81-.57,3.74-.4,5.43.48.99.52,2.15.62,3.21.28,1.07-.34,1.96-1.08,2.47-2.07l16.6-31.84c1.08-2.06.28-4.61-1.79-5.69ZM52.78,54.54c-2.58-.54-5.27-.42-7.85.39-2.58.81-4.86,2.25-6.66,4.17l-28.36-14.79L27.85,9.9l37.9,19.77-12.97,24.87Z"/>
    <Path d="M21.21,40.79c.33,1.07,1.08,1.96,2.07,2.47l17.74,9.25c.61.32,1.28.48,1.95.48.43,0,.85-.06,1.27-.19,1.07-.33,1.96-1.08,2.47-2.07l7.47-14.32c1.08-2.06.28-4.61-1.79-5.69l-17.73-9.25c-2.06-1.08-4.61-.27-5.69,1.79l-7.47,14.32c-.52.99-.62,2.15-.28,3.22ZM34.48,30.9l10.26,5.35-3.57,6.84-10.26-5.35,3.57-6.84Z"/>
    <Path d="M50.13,70.3c-2.47,0-4.47,2-4.47,4.47s2,4.47,4.47,4.47,4.47-2,4.47-4.47-2-4.47-4.47-4.47Z"/>
    <Circle cx="42.02" cy="88.1" r="4.47"/>
    <Circle cx="59.07" cy="93.12" r="4.47"/>
    <Circle cx="29.78" cy="104.95" r="4.47"/>
    <Circle cx="47.59" cy="103.57" r="4.47"/>
    <Circle cx="63.19" cy="110.31" r="4.47"/>
  </G>
</Svg>
);
};

export default Poudre;
